module.exports = __webpack_public_path__ + "img/four1Orange.368eac1b.jpg";